/*
 * File: cell-image.ts
 * File Created: 2023-12-19 06:50:09
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-23 11:19:29
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "../../../core/lib/base-table-body-cell/base-table-body-cell";

@Component
export default class CellImage extends BaseTableBodyCell {}
